import React, { useState } from 'react';
import './Case.css';
import { PageHead } from '../../Components';
import { useTranslation } from 'react-i18next';

// const DEFAULT_API = 'http://localhost/server/testServer';
const DEFAULT_API = 'https://www.albarede.com/server';

function CaseQuery({ apiBase = DEFAULT_API }) {
  const [caseNumber, setCaseNumber] = useState('');
  const [caseData, setCaseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { t, i18n } = useTranslation();

  const handleSearch = (e) => {
    e.preventDefault();
    if (!caseNumber.trim()) {
      setError('الرجاء إدخال الرقم المرجعي للقضية.');
      return;
    }

    setLoading(true);
    setError('');
    setCaseData(null);

    fetch(`${apiBase}/case.php?case_number=${encodeURIComponent(caseNumber.trim())}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.success) {
          setCaseData(d.data);
        } else {
          setError(d.error || 'لم يتم العثور على قضية بهذا الرقم.');
        }
      })
      .catch(() => setError('حدث خطأ في الاتصال بالسيرفر. الرجاء المحاولة لاحقاً.'))
      .finally(() => setLoading(false));
  };

  const fmtDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <>
    <div className="case-query-container" dir="rtl">
      <div className="case-query-card">
        <form onSubmit={handleSearch} className="case-query-form">
          <p className='putNumber'>أدخل الرقم المرجعي السري الممنوح لك من قبل المكتب لمتابعة آخر تحديثات ومجريات دعواك القضائية.</p>
          <div className="form-group">
            <label htmlFor="caseNumberInput">الرقم المرجعي للقضية</label>
            <input
              id="caseNumberInput"
              type="text"
              placeholder="مثال: CASE-2026-8941"
              value={caseNumber}
              onChange={(e) => setCaseNumber(e.target.value)}
              disabled={loading}
              autoComplete="off"
            />
          </div>
          <button type="submit" className="case-submit-btn" disabled={loading}>
            {loading ? 'جاري البحث...' : 'استعلام عن حالة الدعوى'}
          </button>
        </form>

        {error && <div className="case-query-error">{error}</div>}

        {caseData && (
          <div className="case-result-box">
            <div className="result-header">
              <h4>تفاصيل ومجريات القضية</h4>
              <span className={`case-status-badge status-${caseData.status_slug}`}>
                {caseData.status_title}
              </span>
            </div>

            <div className="result-grid">
              <div className="result-item">
                <span className="item-lbl">رقم القضية المرجعي:</span>
                <span className="item-val code-style">{caseData.case_number}</span>
              </div>
              <div className="result-item">
                <span className="item-lbl">اسم الموكل:</span>
                <span className="item-val">{caseData.client_name}</span>
              </div>
              <div className="result-item">
                <span className="item-lbl">تاريخ التحديث الأخير:</span>
                <span className="item-val">{fmtDate(caseData.updated_at)}</span>
              </div>
            </div>

            {caseData.status_description && (
              <div className="case-description-block">
                <h5>التقرير القانوني الحالي المضاف من المكتب:</h5>
                <p>{caseData.status_description}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
    </>
  );
}

export default CaseQuery;